import { getBackgroundColor, getColor } from '../../colors/colors.alias';
import { getFontFamily, getFontSize, getLineHeight, } from '../../typography/typography.alias';
import { VARIANT_DEFAULT, ELEMENT_INDICATOR, ELEMENT_TRACK, ELEMENT_LABEL, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'BarLoader',
    variants: {
        VARIANT_DEFAULT,
    },
    elements: {
        ELEMENT_INDICATOR,
        ELEMENT_TRACK,
        ELEMENT_LABEL,
    },
});
export default function getBarLoader(transformer, config) {
    const backgroundColor = getBackgroundColor(transformer, config);
    const fontFamily = getFontFamily(transformer, config);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const color = getColor(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_INDICATOR]: {
                styles: {
                    backgroundColor: backgroundColor.barLoader.indicator.value,
                },
            },
            [ELEMENT_TRACK]: {
                styles: {
                    backgroundColor: backgroundColor.barLoader.track.value,
                    borderRadius: '8px',
                },
            },
            [ELEMENT_LABEL]: {
                styles: {
                    fontFamily: fontFamily.body.value,
                    fontSize: fontSize.body.m.value,
                    lineHeight: lineHeight.body.get(fontSize.body.m.value),
                    color: color.text.default.value,
                    textAlign: 'center',
                },
            },
        },
    });
}
